import styled from 'styled-components';

export const StyledLightningAlert = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  box-shadow: 0px 6px 24px 0px #0000001f;
  width: 400px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  z-index: 100;

  .la-header {
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    border-bottom: 1px solid #eeeeee;
    cursor: grab;
    user-select: none;

    &:active {
      cursor: grabbing;
    }
  }

  .la-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .la-close-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .la-close-btn img {
    width: 20px;
    height: 20px;
  }

  .la-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 20px 18px 16px;
  }

  .la-message {
    font-size: 14px;
    font-weight: 400;
    color: #2f2f35;
    text-align: center;
    line-height: 1.7;
    margin: 0;
  }

  .la-status-card {
    width: 100%;
    border-radius: 6px;
    position: relative;
    margin-top: 4px;
    box-sizing: border-box;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #dadada;
  }

  .la-badge {
    position: absolute;
    top: 12px;
    left: 12px;
    font-size: 11px;
    font-weight: 600;
    color: #ffffff;
    padding: 2px 10px;
    border-radius: 2px;
  }

  .la-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .la-info-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 13px;
  }

  .la-info-label {
    font-weight: 600;
    font-size: 14px;
    color: #2f2f35;
  }

  .la-info-value {
    font-weight: 500;
    font-size: 14px;
  }

  .la-footer {
    display: flex;
    justify-content: end;
    gap: 10px;
    padding: 4px 18px 18px;
  }

  .la-btn {
    width: 67px;
    height: 37px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .la-btn-close {
    background-color: #f8f8f8;
    border: 1px solid #dadada;
    color: #a4a7a7;
    font-size: 14px;
    font-weight: 500;
  }

  .la-btn-ok {
    background-color: #055cb4;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
  }

  /* Caution */
  .la-status-card.la-caution {
    background-color: #f0f8fe;
  }
  .la-status-card.la-caution .la-badge {
    background-color: #60b0f2;
  }
  .la-status-card.la-caution .la-highlight {
    color: #60b0f2;
  }

  /* Warning */
  .la-status-card.la-warning {
    background-color: #fffaeb;
  }
  .la-status-card.la-warning .la-badge {
    background-color: #ffcb30;
  }
  .la-status-card.la-warning .la-highlight {
    color: #ffcb30;
  }

  /* Danger */
  .la-status-card.la-danger {
    background-color: #fff6ef;
  }
  .la-status-card.la-danger .la-badge {
    background-color: #ff8f31;
  }
  .la-status-card.la-danger .la-highlight {
    color: #ff8f31;
  }

  /* Emergency */
  .la-status-card.la-emergency {
    background-color: #ffedec;
  }
  .la-status-card.la-emergency .la-badge {
    background-color: #fc1e0f;
  }
  .la-status-card.la-emergency .la-highlight {
    color: #fc1e0f;
  }

  /* Normal */
  .la-status-card.la-normal {
    background-color: #67d0871a;
  }
  .la-status-card.la-normal .la-badge {
    background-color: #67d087;
  }
  .la-status-card.la-normal .la-highlight {
    color: #67d087;
  }
`;
